<h1 mat-dialog-title>
  Publish deal
  @if (error$ | async; as message) {
    <div class="warning">
      <mat-icon>warning</mat-icon>
      <span [innerText]="message"></span>
    </div>
  }
  <semeris-loader [loading]="loading$ | async" [inline]="true"></semeris-loader>
</h1>
<div class="container" mat-dialog-content>
  <form [formGroup]="form">
    <mat-form-field color="accent">
      <mat-label>Library Transaction Id</mat-label>
      <input matInput lowercase formControlName="transactionId" autocomplete="off" required />
      @if (form | formControlError: 'transactionId'; as error) {
        <mat-error>{{ error }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field color="accent">
      <mat-label>Manager</mat-label>
      <input type="text" matInput formControlName="managerId" [matAutocomplete]="auto" required />
      <mat-autocomplete #auto="matAutocomplete" class="manager-autocomplete" autoActiveFirstOption="true">
        @for (option of managerOptions$ | async; track option.value) {
          <mat-option [value]="option.value">
            <span [innerHtml]="option.text | boldSpan: form?.value?.managerId | safeHtml"></span>
          </mat-option>
        }
      </mat-autocomplete>
      @if (form | formControlError: 'managerId'; as error) {
        <mat-error>{{ error }}</mat-error>
      }
    </mat-form-field>

    @if (isTransactionReadyForPublish$ | async) {
      <ng-container *ngIfVersion="['local', 'dev']">
        <div class="mat-form-field-wrapper slide-toggle-form-field">
          <mat-slide-toggle color="accent" formControlName="publishToDev">Publish to dev</mat-slide-toggle>
        </div>
      </ng-container>
      <ng-container *ngIfVersion="['staging', 'production', 'produsb']">
        <div class="mat-form-field-wrapper slide-toggle-form-field">
          <mat-slide-toggle color="accent" formControlName="publishToStaging">Publish to staging</mat-slide-toggle>
        </div>
        <div class="mat-form-field-wrapper slide-toggle-form-field">
          <mat-slide-toggle color="accent" formControlName="publishToProd"
            >Publish to production
            <span class="additional-info"
              >Publishing to this environment only occurs if the appropriate library is available.</span
            ></mat-slide-toggle
          >
        </div>
        <div class="mat-form-field-wrapper slide-toggle-form-field">
          <mat-slide-toggle color="accent" formControlName="publishToProdusb"
            >Publish to produsb (US Bank)
            <span class="additional-info"
              >Publishing to this environment only occurs if the appropriate library is available.</span
            ></mat-slide-toggle
          >
        </div>
      </ng-container>
      <label id="document-list" class="title">Document to be extracted</label>
      <mat-radio-group
        aria-labelledby="document-list"
        formControlName="documentShortName"
        class="horizontal-radio-group">
        <mat-radio-button [value]="null">None</mat-radio-button>
        @for (document of documentShortNames$ | async; track document) {
          <mat-radio-button [value]="document">
            {{ document }}
          </mat-radio-button>
        }
      </mat-radio-group>
      <div class="mat-form-field-wrapper slide-toggle-form-field">
        <mat-slide-toggle color="accent" formControlName="clearDatafactoryAndSemtexFiles"
          >Clear Datafactory + Semtex + Olym files
        </mat-slide-toggle>
      </div>

      <mat-divider class="section-divider"></mat-divider>
      @if (docBundleId$ | async; as docBundleId) {
        <h2>Deal Queue</h2>

        @let createdAt = task()?.createdAt;
        <div class="create-transaction-task-container">
          <button
            semerisButton
            color="accent"
            [variant]="createdAt ? 'outline' : 'raised'"
            (confirm)="onTaskCreate()"
            confirmColor="accent"
            confirmTitle="Create a new Deal Queue Task?">
            <mat-icon [color]="createdAt ? 'accent' : ''">add</mat-icon>
            Create Task
          </button>

          @if (taskLoading()) {
            <semeris-loader [inline]="true" [loading]="true"></semeris-loader>
          } @else if ((createdAt && !taskCreatedId()) || (taskCreatedId() && taskCreatedId() !== task()?._id)) {
            <semeris-warning mode="outline">
              Task already exists - created <strong>{{ createdAt | userDateTimeFormat }}</strong>
            </semeris-warning>
          }
        </div>

        @if (task()) {
          <semeris-transaction-task-table
            [items]="transactionTaskStore.tableItems().items"
            [pinnedItems]="transactionTaskStore.tableItems().pinnedItems"
            [actionsEnabled]="false"
            [resizeHandlesEnabled]="false"
            [columns]="transactionTaskStore.tableColumns()"
            [users]="transactionTaskStore.users()"
            [currentUserId]="transactionTaskStore.currentUserId()"
            [loading]="transactionTaskStore.loading()"
            [labels]="transactionTaskStore.otherLabels()"
            [statusLabels]="transactionTaskStore.statusLabels()"
            (itemChange)="transactionTaskStore.onUpdateTransactionTask($event.id, $event.change)"
            (labelsChange)="transactionTaskStore.onLabelsChanged($event.id, $event.labels)"
            (statusLabelsChange)="transactionTaskStore.onLabelsChanged($event.id, $event.statusLabels, 'statusLabel')"
            (delete)="transactionTaskStore.onDeleteTransactionTask($event.id)">
          </semeris-transaction-task-table>
        }
      }
    }
  </form>
</div>
<div class="actions" mat-dialog-actions align="end">
  <button semerisButton variant="text" [mat-dialog-close]="false">Cancel</button>
  <button
    semerisButton
    variant="raised"
    cdkFocusInitial
    (click)="save()"
    [disabled]="!(isTransactionReadyForPublish$ | async)"
    color="accent">
    Publish
  </button>
</div>
